<template>
  <i class="ri-line-chart-line" @click="openChart"/>
</template>

<script>

import eventBus from "../../services/events";
export default {
  name: "symbolChart",
  props: ['symbol'],
  methods: {
    openChart() {

      eventBus.emit('chartWindow', this.symbol);
    }
  }
}
</script>

<style scoped lang="scss">

  @import "../../assets/style/general";

  i {
    background: var(--tableHoverColorOpacity);
    padding: 5px;
    border-radius: 4px;
    cursor: pointer;
    z-index: 9;
  }
</style>
